import React from "react";

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Nossos Serviços</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (                
                <div key={`${d.title}-${i}`} className="col-xs-6 col-lg-2">
                  {" "}
                  <img src={d.smallImage} alt={d.title} className="feature-image"/>                  
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Carregando..."}
        </div>
      </div>
    </div>
  );
};
